import { Row, Col } from 'antd';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';

import { PrimaryButton, SecondaryButton } from './Button';
import Label from './Label';

import img_bg_desktop from '../assets/Img_hero_bg_desktop.jpg';
import img_bg_mobile from '../assets/Img_hero_bg_mobile.png';
import img_bg_pets from '../assets/img_hero_pets.png';
import img_wave from '../assets/img_wave_desktop.png';
import { CONSULT_SURVEY } from '../data/url';

const WaveImg = styled.img`
    width: 100%;
    position: absolute;
    bottom: -50px;
    left: 0px;
    right: 0px;

    @media screen and (max-width: 992px) {
        bottom: -20px;
    }
`;

const PetImg = styled.img`
    position: absolute;
    left: 100px;
    bottom: -40px;
    width: 450px;
    z-index: 10;

    @media screen and (max-width: 992px) {
        display: none;
    }
`;

const Banner = () => {
    const [contentOpacity, setContentOpacity] = useState(0);
    
    useEffect(() => {
        setTimeout(() => setContentOpacity(1), 500);
    }, []);

    const scrollToAnchor = (anchor: string) => {
        const target = document.getElementById(anchor);
        target?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div style={{ position: 'relative' }}>
            <Row>
                <Col lg={24} md={0} sm={0} xs={0} style={{ position: 'relative' }}>
                    <img src={img_bg_desktop} alt='img_bg_desktop' style={{ width: '100vw', position: 'relative' }}/>
                    <div style={{ position: 'absolute', left: '120px', top: '160px', opacity: contentOpacity, transition: 'opacity 1s' }}>
                        <Row style={{ marginBottom: '30px' }}>
                            <Label text='企業健康促進'/>
                            <div style={{ margin: '0px 15px' }}></div>
                            <Label text='運動 AI 化'/>
                        </Row>
                        <Row style={{ margin: '24px 0px 48px', fontSize: '36px', fontWeight: 700, lineHeight: '48px' }}>
                            輕鬆打造企業運動賽事，<br/>活用AI工具，達成生活平衡補助
                        </Row>
                        <Row style={{ marginBottom: '30px' }}>
                            <PrimaryButton newTab href={CONSULT_SURVEY} content='立即洽詢'/>
                            <div style={{ margin: '0px 10px' }}></div>
                            <SecondaryButton onClick={() => scrollToAnchor('solution')} content='查看優惠方案'/>
                        </Row>
                    </div>
                </Col>
                <Col lg={0} md={24} sm={24} xs={24} style={{ backgroundColor: '#ECF4FD' }}>
                    <div style={{marginTop: '24px', textAlign: 'center', opacity: contentOpacity, transition: 'opacity 1s' }}>
                        <Row justify='center' style={{ marginBottom: '40px' }}>
                            <Label text='企業健康促進'/>
                            <div style={{ margin: '0px 15px' }}></div>
                            <Label text='運動 AI 化'/>
                        </Row>
                        <Row style={{ margin: '24px 0px 32px', fontSize: '36px', padding: '0px 30px', fontWeight: 700, lineHeight: '48px' }}>
                            輕鬆打造企業運動賽事，激發員工活力，達成 ESG 永續目標
                        </Row>
                        <Row align='middle' style={{ flexDirection: 'column', marginBottom: '40px' }}>
                            <PrimaryButton newTab href={CONSULT_SURVEY} content='立即洽詢'/>
                            <div style={{ margin: '10px 0px' }}></div>
                            <SecondaryButton onClick={() => scrollToAnchor('solution')} content='查看優惠方案'/>
                        </Row>
                    </div>
                    <img src={img_bg_mobile} alt='img_bg_mobile' style={{ width: '100vw', position: 'relative' }}/>
                </Col>
            </Row>
            <PetImg src={img_bg_pets} alt='img_bg_pets' />
            <WaveImg src={img_wave} alt='img_wave' />
        </div>
    );
};

export default Banner;
